
import React from 'react';
import { AppRoute } from '../types';

interface FooterProps {
  onNavigate?: (route: AppRoute) => void;
}

const Footer: React.FC<FooterProps> = ({ onNavigate }) => {
  return (
    <footer className="bg-primary text-white pt-20 md:pt-32 pb-0 px-6 md:px-12 overflow-hidden relative">
      <div className="max-w-[1400px] mx-auto">
        {/* Top Section */}
        <div className="flex flex-col md:flex-row justify-between items-start gap-16 mb-24 md:mb-40">
          {/* Left: Headline and Action */}
          <div className="space-y-10 max-w-sm">
            <h2 className="text-4xl md:text-6xl font-display uppercase tracking-tighter leading-[0.9]">Relax.<br/> We got you.</h2>
            <button 
              className="border border-white/30 rounded-full px-10 py-4 text-[11px] font-bold uppercase tracking-widest hover:bg-white hover:text-black transition-all duration-300 active:scale-95"
              onClick={() => window.location.href = 'mailto:bedanta.design@gmail.com'}
            >
              Contact Support
            </button>
          </div>

          {/* Right: Navigation and Socials */}
          <div className="grid grid-cols-2 gap-12 sm:gap-24 md:gap-40 text-[11px] font-bold uppercase tracking-[0.2em]">
            {/* Nav Links */}
            <div className="space-y-5 flex flex-col items-start">
              <span className="text-neutral-500 mb-2 border-b border-white/10 w-full pb-2">Platform</span>
              <button onClick={() => onNavigate?.(AppRoute.HOME)} className="hover:text-neutral-400 transition-colors py-1">Home</button>
              <button onClick={() => onNavigate?.(AppRoute.PRINTER_OWNER)} className="hover:text-neutral-400 transition-colors py-1">Node Owner</button>
              <button onClick={() => onNavigate?.(AppRoute.ABOUT)} className="hover:text-neutral-400 transition-colors py-1">Mission</button>
              <button onClick={() => onNavigate?.(AppRoute.FOR_MAKERS)} className="hover:text-neutral-400 transition-colors py-1">Designers</button>
            </div>

            {/* Social Links */}
            <div className="space-y-5 flex flex-col items-start">
              <span className="text-neutral-500 mb-2 border-b border-white/10 w-full pb-2">Social</span>
              <a href="#" className="flex items-center gap-2 group hover:text-neutral-400 transition-colors py-1">
                X <iconify-icon icon="lucide:arrow-up-right" width="14" class="opacity-50 group-hover:opacity-100 transition-opacity"></iconify-icon>
              </a>
              <a href="#" className="flex items-center gap-2 group hover:text-neutral-400 transition-colors py-1">
                Insta <iconify-icon icon="lucide:arrow-up-right" width="14" class="opacity-50 group-hover:opacity-100 transition-opacity"></iconify-icon>
              </a>
              <a href="#" className="flex items-center gap-2 group hover:text-neutral-400 transition-colors py-1">
                LinkedIn <iconify-icon icon="lucide:arrow-up-right" width="14" class="opacity-50 group-hover:opacity-100 transition-opacity"></iconify-icon>
              </a>
            </div>
          </div>
        </div>

        {/* Middle Section: Meta Info */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-end gap-12 mb-8 border-t border-white/10 pt-12">
          <div className="text-[11px] font-mono uppercase tracking-[0.3em] space-y-3 text-neutral-500">
            <p className="flex items-center gap-2"><iconify-icon icon="lucide:map-pin" class="text-xs"></iconify-icon> HSR-BANGALORE / IN</p>
            <p className="flex items-center gap-2"><iconify-icon icon="lucide:globe" class="text-xs"></iconify-icon> Distributed Protocol</p>
          </div>

          <div className="flex flex-col md:items-end gap-3 text-[11px] font-mono uppercase tracking-[0.3em]">
            <a href="mailto:bedanta.design@gmail.com" className="hover:text-neutral-400 transition-colors">bedanta.design@gmail.com</a>
            <p className="text-neutral-600">©2024 distributed systems v1.0</p>
          </div>
        </div>

        {/* Massive Brand - Aeronixsa Restoration */}
        {/* Adjusted tracking and font size for Aeronixsa specifically */}
        <div className="relative pt-8 pointer-events-none select-none overflow-visible">
          <h1 className="text-[22vw] md:text-[20.5vw] leading-[0.8] font-display font-bold lowercase tracking-[-0.03em] opacity-100 whitespace-nowrap -ml-2 pb-8 md:pb-16 text-center">
            zetra
          </h1>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
